
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { translate } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import SessionByCaseId from './by-case-id/ByCaseId'
import SessionByDecision from './by-decision/ByDecision'
import ActionModal from '../../common/ActionModal'
import * as actions from '../../../actionTypes'
import { Button } from '@material-ui/core';

const styles = theme => ({
  root: {flexGrow: 1},
  "m-b-3": { marginBottom: '3em' }
})

class RecallSessionForm extends Component {
  state ={ 
    showAlert: false,
    pendingSessionId: null,
    pendingSessionPath: null
  }

  recall = (session, path) => {
    const sessionId = session.sessionId
    if (session.languageCode && session.languageCode.toLowerCase() !== this.props.lang) {
      return this.setState({ 
        showAlert: true,
        pendingSessionId: sessionId,
        pendingSessionPath: path
     })
    }
    return this.props.recallSession(sessionId, path)  
  }

  closeAlert = () => this.setState({ showAlert: false, pendingSessionId: null })
  continueAlert = () => this.props.recallSession(this.state.pendingSessionId, this.state.pendingSessionPath)

  render() {
    const { classes, availableDecisions, t } = this.props
    const { showAlert } = this.state
    const { recall, closeAlert, continueAlert } = this
    return (
      <div className={classes.root}>
        <Grid
          container
          direction="column"
        >
          <Grid className={classes['m-b-3']}>
            <SessionByCaseId recallSession={recall} />
          </Grid>
          <Grid className={classes['m-b-3']}>
            <SessionByDecision 
              recallSession={recall}
              availableDecisions={availableDecisions} 
            />
          </Grid>
        </Grid>
        <ActionModal
          open={showAlert}
          content={t('Selected Language Changed')}
          onDismiss={closeAlert}
          dismissText={t('Cancel')}
          buttons={[(
            <Button
              color="primary"
              onClick={continueAlert}
            >{t('Continue')}</Button>
          )]}
        />
     </div>
    )
  }

}


RecallSessionForm.defaultProps = {
  availableDecisions: {},
  classes: {}
}

RecallSessionForm.propTypes = {
  lang: PropTypes.string.isRequired,
  availableDecisions: PropTypes.object,
  classes: PropTypes.object,
  recallSession: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}


const mapDispatchToProps = dispatch => ({
  recallSession(sessionId, path) {
    const action = {type: actions.SESSION_RECALL_REQUESTED, payload: {sessionId, path}}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  lang: state.globalSettings.lang
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  translate()
)(RecallSessionForm)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/RecallSessionForm.js